import "./App.css";
import { Games } from "./features/game";

function App() {
  return (
    <div className="appContainer">
      <Games />
    </div>
  );
}

export default App;
